const Medal = (props) => (
  <svg
    fill="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 512 512"
    {...props}
  >
    <g>
      <path
        d="M250.172,384.856c-11.713-2.187-20.767-10.655-28.256-17.651c-3.959-3.681-9.376-8.747-12.17-9.483
          c-0.364-0.108-1.036-0.214-2.208-0.214c-3.68,0-8.875,1.194-13.899,2.336c-6.603,1.515-13.449,3.08-20.438,3.08
          c-6.589,0-12.406-1.45-17.366-4.309c-1.565-0.915-3.016-1.929-4.33-3.008l-50.537,109.143l62.814-1.879l39.19,49.13
          l53.024-114.545l5.846-12.599c-1.879,0.372-3.83,0.564-5.846,0.564C253.988,385.42,252.037,385.228,250.172,384.856z"
      />
      <path
        d="M356.185,358.594c-4.959,2.88-10.805,4.33-17.365,4.33c0,0,0,0-0.022,0c-6.996,0-13.814-1.565-20.416-3.08
          c-5.024-1.143-10.219-2.336-13.928-2.336c-1.144,0-1.837,0.107-2.208,0.214c-2.787,0.736-8.204,5.802-12.142,9.483
          c-1.864,1.736-3.815,3.559-5.866,5.352l-19.881,42.934L309.028,512l39.211-49.13l62.815,1.879l-50.559-109.171
          C359.172,356.686,357.743,357.679,356.185,358.594z"
      />
      <path
        d="M256.004,81.194c-57.398,0-103.934,46.536-103.934,103.934c0,57.398,46.535,103.934,103.934,103.934
          c57.397,0,103.933-46.536,103.933-103.934C359.937,127.73,313.401,81.194,256.004,81.194z"
      />
      <path
        d="M413.955,227.462c3.852-14.4,27.177-26.72,27.177-42.334c0-15.607-23.325-27.927-27.177-42.326
          c-3.98-14.9,9.94-37.225,2.402-50.259c-7.661-13.228-34.016-12.277-44.756-23.018c-10.741-10.72-9.784-37.089-23.018-44.756
          c-13.028-7.532-35.36,6.388-50.252,2.408C283.952,23.34,271.611,0,255.996,0c-15.586,0-27.927,23.34-42.327,27.177
          c-14.878,3.98-37.203-9.94-50.258-2.408c-13.206,7.668-12.278,34.036-22.997,44.756c-10.733,10.741-37.11,9.79-44.756,23.018
          c-7.553,13.034,6.388,35.359,2.408,50.259c-3.859,14.399-27.198,26.719-27.198,42.326c0,15.614,23.339,27.934,27.198,42.334
          c3.98,14.899-9.961,37.224-2.408,50.259c7.646,13.228,34.023,12.27,44.756,23.01c4.938,4.938,7.39,13.17,9.897,21.353
          c2.123,6.974,4.288,13.92,8.012,18.794c1.429,1.887,3.101,3.466,5.088,4.61c13.034,7.539,35.38-6.382,50.258-2.401
          c9.204,2.45,17.558,12.842,26.456,20.052c5.024,4.066,10.248,7.124,15.871,7.124c5.631,0,10.848-3.058,15.893-7.124
          c8.732-7.06,16.936-17.194,25.897-19.88c0.172-0.064,0.372-0.129,0.544-0.171c14.892-3.981,37.224,9.94,50.252,2.401
          c1.993-1.144,3.688-2.744,5.116-4.631c8.096-10.633,8.789-31.029,17.901-40.126c10.74-10.741,37.096-9.783,44.756-23.01
          C423.895,264.686,409.974,242.361,413.955,227.462z M255.996,308.549c-2.401,0-4.78-0.064-7.139-0.214
          c-29.692-1.686-56.562-13.856-76.957-32.894c-24.211-22.539-39.325-54.646-39.325-90.313
          c0-68.16,55.261-123.421,123.421-123.421c68.167,0,123.421,55.262,123.421,123.421
          C379.417,253.295,324.163,308.549,255.996,308.549z"
      />
    </g>
  </svg>
);

export default Medal;
